import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { ApuStandardCategoryActions } from "./apu-standard-category.actions";
import { ApuStandardCategoryService } from "@/core/services/apu-standard-category.service";
import { ApuStandardCategoryApiModel } from "@/core/models/api/apu-standard-category-api.model";

@Injectable()
export class ApuStandardCategoryEffects {
    actions$ = inject(Actions);
    apuStandardCategoryService = inject(ApuStandardCategoryService);

    constructor(){

    }

    _loadApuStandardCategoryType = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuStandardCategoryActions.loadApuStandardCategories),
            exhaustMap(() => {
                return this.apuStandardCategoryService.getAll().pipe(
                    map((response: any) => {
                        const apuStandardCategories = response as ApuStandardCategoryApiModel[];
                        return ApuStandardCategoryActions.loadApuStandardCategorySuccess({ apuStandardCategories });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _addRange = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuStandardCategoryActions.addRangeApuStandardCategories),
            exhaustMap((action) => {
                return this.apuStandardCategoryService.addRange(action.apuStandardCategoryList).pipe(
                    map((response: any) => {
                        const apuStandardCategory = response as ApuStandardCategoryApiModel;
                        return ApuStandardCategoryActions.addRangeApuStandardCategorySuccess({ apuStandardCategory });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })

    _delete = createEffect(() => {
        return this.actions$.pipe(
            ofType(ApuStandardCategoryActions.deleteApuStandardCategory),
            exhaustMap((action) => {
                return this.apuStandardCategoryService.delete(action.apuStandardCategoryId).pipe(
                    map((response: any) => {
                        console.log('RESPONSE: ', response);
                        return ApuStandardCategoryActions.deleteApuStandardCategorySuccess({ apuStandardCategoryId: action.apuStandardCategoryId });
                    }),
                    catchError((error) => {
                        console.error(error);
                        return of();
                    })
                )
            })
        )
    })
}